import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppBar, Toolbar, IconButton, Typography, Container, Box, Button, Link, Menu } from '@mui/material';
import { Link as RLink, useNavigate } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu'

import Logo from '../../assets/dreampix_logo.png';

export function Header() {
  const navigate = useNavigate();

  return (
    <AppBar position="sticky" sx={{
      background: '#00000022',
      backdropFilter: 'blur(3px)',
      boxShadow: '0px 1px 10px 0px #00000044',
    }}>
      <Toolbar sx={{
        // backgroundColor: '#12121200'
      }}>
        {/* <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
        <MenuIcon />
      </IconButton> */}
        <Box>
          <RLink to="/" style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={Logo}
              style={{ height: '3rem', width: 'auto' }}
              alt="DreamPix Logo"
            />
            {/* <LogoText /> */}
          </RLink>
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        <Button
          color="inherit"
          sx={{
            fontSize: { xs: '0.8rem', sm: '1rem' },
            display: { xs: 'none', sm: 'flex' },
          }}
          onClick={() => {
            navigate('/')
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }}>
          Features
        </Button>
        <Button
          color="inherit"
          sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}
          onClick={() => {
            navigate('/app')
            // window.scrollTo({
            //   top: 10000,
            //   behavior: "smooth",
            // })
          }}>
          APP
        </Button>

        <Button
          color="inherit"
          sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}
          onClick={() => {
            navigate('/app/topup')
          }}>
          Top UP
        </Button>

        {/* <Button
          component={RLink}
          color="inherit"
          sx={{
            ml: 2,
            fontSize: { xs: '0.8rem', sm: '1rem' },
            backgroundColor: 'rgba(255,255,255,0.25)',
          }}
          to="https://token.dreampix.art/"
          href='https://token.dreampix.art/'
          target='_blank'
          rel='noopener noreferrer'
        >
          TOKEN
        </Button> */}
      </Toolbar>
    </AppBar>
  );
}

function LogoText() {
  return (
    <svg viewBox="0 0 100 25" preserveAspectRatio="xMidYMid meet"
      style={{
        maxWidth: '10vw',
        maxHeight: '100%',
        height: '3rem'
      }}>
      <defs>
        <linearGradient id="animatedGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stop-color="#ff9f1c">
            <animate attributeName="offset" values="0;1;0" dur="8s" repeatCount="indefinite" />
          </stop>
          <stop offset="50%" stop-color="#2ec4b6">
            <animate attributeName="offset" values="0.5;0;0.5" dur="8s" repeatCount="indefinite" />
          </stop>
          <stop offset="100%" stop-color="#e71d36">
            <animate attributeName="offset" values="1;0;1" dur="8s" repeatCount="indefinite" />
          </stop>
        </linearGradient>
      </defs>

      <g filter="url(#goo)">
        <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="10"
          style={{
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            fontWeight: 'bold',
            fill: "url(#animatedGradient)",
          }}>
          DreamPix
        </text>
      </g>
    </svg >
  )
}

export default Header;
